
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';
	import IQubeScannerSVG from '@/components/IQubeScannerSVG.vue';
	import TigerScannerSVG from '@/components/TigerScannerSVG.vue';
	import ShoeSizePicker from '@/components/ShoeSizePicker.vue';
	import { packs } from '@/store/ProductStore';
	import HPAgentModule from '@/store/engine/modules/HPAgentModule';
	import { ScanModes } from '@/store/agentStore';
	import GearsSVG from '@/components/GearsSVG.vue';
	import DualButtonModal from '@/components/modals/DualButtonModal.vue';
	import errorMessages from '@/assets/error-messages.json';
	@Observer
	@Component({
		components: { DualButtonModal, GearsSVG, ShoeSizePicker, TigerScannerSVG, IQubeScannerSVG }
	})
	export default class ScanSettings extends Vue {
		public options = packs;
		public availableDevices: any[] = [];
		private agent: HPAgentModule = this.$state.engine.agent;
		private websocketError = false;
		private clicked = true;
		private reload = 0;
		private noHealthyDevicesModal = false;
		private errorMessages: any;

		async created(): Promise<void> {
			this.errorMessages = errorMessages;
			window.addEventListener('socketError', async (e) => {
				this.websocketError = true;
			});

			if (this.agent.agentStatus === 0) {
				// disconected
				await this.connectToHPAgent();
			}

			this.availableDevices = this.agent.devices;

			window.addEventListener('OnDeviceAttached', async (e) => {
				this.availableDevices = this.agent.devices;
			});
		}

		async updated() {
			if (this.agent.agentStatus === 0) {
				// disconected
				await this.connectToHPAgent();
			}
		}

		async mounted(): Promise<void> {
			if (this.agent.agentStatus === 0) {
				// disconected
				await this.connectToHPAgent();
			}
			this.availableDevices = this.agent.devices;
		}

		async activated() {
			if (this.agent.agentStatus === 0) {
				// disconected
				await this.connectToHPAgent();
			}
			this.availableDevices = this.agent.devices;
		}

		// FIXME(vermecz): Needs to refactor and share connectToHPAgent with ThreeDScan.
		public async connectToHPAgent() {
			const opened = await this.agent.open();
			this.noHealthyDevicesModal = this.agent.devices.length === 0;
		}

		async setScannerSetting(scanMode: ScanModes) {
			const device = this.agent.devices.find((d) => d.name.includes('Tiger'));
			if (device) {
				await this.$state.agent.setCurrentDevice(device);
				this.$state.agent.setScanSettings(scanMode);
				await this.next();
			}
		}

		async setIQubeScanner(scanMode: ScanModes) {
			const device = this.agent.devices.find((d) => d.name.includes('iQube'));
			if (device) {
				await this.$state.agent.setCurrentDevice(device);
				this.$state.agent.setScanSettings(scanMode);
				await this.next();
			}
		}

		async setMock() {
			const device = this.agent.devices.find((d) => d.name.includes('Mock'));
			if (device) {
				await this.$state.agent.setCurrentDevice(device);
				this.$state.agent.setScanSettings('SEMI_WEIGHTED');
				await this.next();
			}
		}

		isDevice(name) {
			return this.availableDevices?.find((d) => d.name.includes(name));
		}

		private isDisabled(type: string) {
			switch (type) {
				case 'Pair':
					if (this.$state.biometric.bothScansExist) return false;
					return true;
				case 'Left Only':
					if (this.$state.biometric.bothScansExist || this.$state.biometric.leftScanExists) return false;
					return true;
				case 'Right Only':
					if (this.$state.biometric.bothScansExist || this.$state.biometric.rightScanExists) return false;
					return true;
			}
		}

		private restart() {
			this.$router.push('patients');
			location.reload();
		}

		private async reconnect() {
			if (this.agent.agentStatus === 0) {
				// disconected
				await this.connectToHPAgent();
				this.availableDevices = this.agent.devices;
				this.websocketError = false;
			}
		}

		private async back() {
			await this.$router.push('/getting-started');
		}

		private async next() {
			await this.$router.push('/threed');
		}
	}
